const RECOMMENDATIONS_CONTEXT_KEY = 'seatshop-recommendations-context';
const RECOMMENDATIONS_CONTEXT_TTL = 2 * 60 * 60 * 1000;

function storeSharedRecommendationContext(values) {
    if (!Array.isArray(values) || values.length < 1) return;

    const build_ids = [...new Set(values
        .map(value => value?.build_id)
        .filter(build_id => build_id != null)
        .map(build_id => String(build_id)))];

    if (build_ids.length < 1) return;

    try {
        localStorage.setItem(RECOMMENDATIONS_CONTEXT_KEY, JSON.stringify({
            build_ids,
            values,
            expires_at: Date.now() + RECOMMENDATIONS_CONTEXT_TTL
        }));
    } catch (error) {
        // Recommendations still work in the current tab when shared storage is unavailable.
    }
}

function removeSharedRecommendationContext() {
    try {
        localStorage.removeItem(RECOMMENDATIONS_CONTEXT_KEY);
    } catch (error) {
        // Ignore storage restrictions; the entry will remain unavailable.
    }
}

function getSharedRecommendationContext(build_id) {
    try {
        const stored = localStorage.getItem(RECOMMENDATIONS_CONTEXT_KEY);
        if (!stored) return null;

        const context = JSON.parse(stored);
        const isExpired = !context.expires_at || context.expires_at < Date.now();
        const includesBuild = Array.isArray(context.build_ids)
            && context.build_ids.includes(String(build_id));

        if (isExpired) {
            removeSharedRecommendationContext();
            return null;
        }

        return includesBuild && Array.isArray(context.values)
            ? context.values
            : null;
    } catch (error) {
        removeSharedRecommendationContext();
        return null;
    }
}

export default {

    /**
     * Sets recommendations for a specific build
     * @param {*} build_id 
     * @param {*} values 
     * @returns 
     */
    storeRecommendations(build_id, values) {
        sessionStorage.setItem(`${build_id}-recommendations`, JSON.stringify(values));
        storeSharedRecommendationContext(values);
    }, 

    /**
     * Gets Build specific recommendations
     * @param {*} build_id 
     * @returns 
     */
    getRecommendations(build_id) {
        let values = sessionStorage.getItem(`${build_id}-recommendations`);

        if (values) {
            try {
                return JSON.parse(values);
            } catch (error) {
                sessionStorage.removeItem(`${build_id}-recommendations`);
            }
        }

        return getSharedRecommendationContext(build_id);
    },

    storeRecommendationContext(values) {
        storeSharedRecommendationContext(values);
    },

    
    storeProducts(products) {
        return sessionStorage.setItem(`ecommerce-products`, JSON.stringify(products)); 
    }, 


    getProducts(build_id) {
        let products = sessionStorage.getItem(`ecommerce-products`); 

        if ( !products ) {
            return null; 
        }

        return JSON.parse( products ); 
    }, 


    storeSelections(slug, values) {
        return sessionStorage.setItem(`${slug}-selections`, JSON.stringify(values)); 
    }, 


    getSelections(slug) {
        let values = sessionStorage.getItem(`${slug}-selections`); 

        if ( !values ) {
            return null; 
        }

        return JSON.parse( values ); 
    }, 

    removeSelections(slug) {
        sessionStorage.removeItem(`${slug}-selections`); 
    }, 


    storePartOptions(build_id, options) {
        sessionStorage.setItem(`${build_id}-options`, JSON.stringify(options)); 
    }, 

    getPartOptions(build_id) {
        let options = sessionStorage.getItem(`${build_id}-options`); 

        if ( !options ) {
            return null; 
        }

        return JSON.parse( options );
    }, 

    storeLastVehicleSelection(selection) {
        sessionStorage.setItem(`last-vehicle-selection`, JSON.stringify(selection)); 
    }, 


    getLastVehicleSelection() {
        let selection = sessionStorage.getItem(`last-vehicle-selection`); 

        if ( !selection ) {
            return null; 
        }

        return JSON.parse( selection );
    }    
}
